import { render, staticRenderFns } from "./StatisticsTab.vue?vue&type=template&id=2546754b&scoped=true"
import script from "./StatisticsTab.vue?vue&type=script&lang=js"
export * from "./StatisticsTab.vue?vue&type=script&lang=js"
import style0 from "./StatisticsTab.vue?vue&type=style&index=0&id=2546754b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2546754b",
  null
  
)

export default component.exports